import React from 'react';
import { Heart, Sparkles, UtensilsCrossed, Camera, Palette, Music } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Heart,
  Sparkles,
  UtensilsCrossed,
  Camera,
  Palette,
  Music
};

const Services = () => {
  return (
    <section id="layanan" className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 className="heading-1" style={{ marginBottom: '16px', fontSize: 'clamp(24px, 4vw, 36px)' }}>
            Layanan Kami
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Solusi lengkap untuk pernikahan impian Anda, dari perencanaan hingga eksekusi sempurna
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '32px'
        }}>
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="product-card"
                style={{
                  background: 'var(--bg-primary)',
                  padding: '40px 32px',
                  borderRadius: '0px',
                  transition: 'all 0.3s ease',
                  cursor: 'default'
                }}
              >
                <div style={{
                  width: '72px',
                  height: '72px',
                  background: 'var(--bg-secondary)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '24px'
                }}>
                  <IconComponent size={36} color="var(--text-primary)" />
                </div>
                <h3 className="heading-2" style={{ marginBottom: '16px' }}>
                  {service.title}
                </h3>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div style={{
          marginTop: '80px',
          padding: '60px 40px',
          background: 'var(--bg-primary)',
          borderRadius: '0px',
          textAlign: 'center'
        }}>
          <h3 className="heading-2" style={{ marginBottom: '16px', fontSize: 'clamp(20px, 3vw, 28px)' }}>
            Tertarik dengan Layanan Kami?
          </h3>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '32px', maxWidth: '600px', margin: '0 auto 32px' }}>
            Hubungi kami untuk konsultasi gratis dan dapatkan penawaran terbaik untuk pernikahan impian Anda
          </p>
          <a
            href="https://wa.me/6285951311360?text=Hallo%20Annisa%20Wedding%20%2C%20Saya%20mau%20konsultasi%20perihal%20Wedding"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Hubungi Kami Sekarang
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
